// Availability check intervals, in minutes. Keep in sync with server/config/checkIntervals.js
export const CHECK_INTERVAL_OPTIONS = [
  { value: 5, label: 'Every 5 minutes' },
  { value: 15, label: 'Every 15 minutes' },
  { value: 30, label: 'Every 30 minutes' },
  { value: 60, label: 'Every hour' },
  { value: 180, label: 'Every 3 hours' },
  { value: 360, label: 'Every 6 hours' },
  { value: 720, label: 'Every 12 hours' },
  { value: 1440, label: 'Once a day' },
  { value: 2880, label: 'Every 2 days' },
  { value: 4320, label: 'Every 3 days' },
  { value: 10080, label: 'Once a week' },
  { value: 20160, label: 'Every 2 weeks' },
  { value: 30240, label: 'Every 3 weeks' },
  { value: 43200, label: 'Once a month' },
  { value: 86400, label: 'Every 2 months' },
  { value: 129600, label: 'Every 3 months' },
  { value: 259200, label: 'Every 6 months' },
];

export const DEFAULT_CHECK_INTERVAL = 360;

export const formatCheckInterval = (minutes) =>
  CHECK_INTERVAL_OPTIONS.find((o) => o.value === (minutes || DEFAULT_CHECK_INTERVAL))?.label
  || `Every ${minutes} minutes`;

// Server picks a random time in [interval/4, interval] after each check; the scheduler
// cycles every 1–5 min, so the real check lands a few minutes after this
export const nextCheckAt = (app) => (app?.nextCheckAt ? new Date(app.nextCheckAt) : null);
